function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = this && this.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0 0 40px 45px;\n  padding: 20px 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  .ant-select-selection-item {\n    height: 26px;\n  }\n  .ant-select-selection-search {\n    margin-left: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    max-width: 716px;\n    margin-bottom: 15px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "Error loading profile."
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "Profile saved successfully."
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "Error saving profile."
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "First Name"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "First Name is required"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "Last Name"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "Last Name is required"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "Email"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "Invalid email address."
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "To change your email address, please contact ",
        ""
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "Language"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "Language is required"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "Select Language"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "Updating..."
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "Save Changes"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "Cancel"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
import React, { useEffect, useState } from "react";
import { Form, Input, Select as AntSelect, Button, message } from "antd";
import styled from "styled-components";
import { t, jt } from "ttag";
import { useHistory } from "react-router-dom";
import { SUPPORT_EMAIL } from "../../services/support/types";
import { ISO_LOCALE_MAP, LANGUAGE_BY_ISO } from "../../services/translation/api";
import Emphasis from "../Emphasis";
import Label from "../Label";
import StickyFooter from "../StickyFooter";
import Loading from "../Loading";
var useForm = Form.useForm;
var Wrap = styled.div(_templateObject());
var Select = styled(AntSelect)(_templateObject1());
var Field = styled(Form.Item)(_templateObject2());
var Presentation = function(param) {
    var getFn = param.getFn, updateFn = param.updateFn;
    var history = useHistory();
    var _useForm = _slicedToArray(useForm(), 1), form = _useForm[0];
    var validateFields = form.validateFields;
    var _useState = _slicedToArray(useState(false), 2), isUpdating = _useState[0], setIsUpdating = _useState[1];
    var _useState1 = _slicedToArray(useState(true), 2), isLoading = _useState1[0], setIsLoading = _useState1[1];
    var _useState2 = _slicedToArray(useState(null), 2), user = _useState2[0], setUser = _useState2[1];
    useEffect(function() {
        function effect() {
            return _effect.apply(this, arguments);
        }
        function _effect() {
            _effect = _asyncToGenerator(function() {
                var data, e;
                return __generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            setIsLoading(true);
                            return [
                                4,
                                getFn()
                            ];
                        case 1:
                            data = _state.sent().data;
                            setUser(data);
                            setIsLoading(false);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            e = _state.sent();
                            message.error(t(_templateObject3()));
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return _effect.apply(this, arguments);
        }
        effect();
    }, [
        form,
        getFn
    ]);
    var onFinish = function() {
        var _ref = _asyncToGenerator(function() {
            var _ref, lastName, firstName, newLanguage, email, e;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            4,
                            5
                        ]);
                        setIsUpdating(true);
                        return [
                            4,
                            validateFields()
                        ];
                    case 1:
                        _ref = _state.sent(), lastName = _ref.lastName, firstName = _ref.firstName, newLanguage = _ref.language, email = _ref.email;
                        return [
                            4,
                            updateFn({
                                lastName: lastName,
                                firstName: firstName,
                                language: newLanguage,
                                email: email
                            })
                        ];
                    case 2:
                        _state.sent();
                        message.success(t(_templateObject4()));
                        return [
                            3,
                            5
                        ];
                    case 3:
                        e = _state.sent();
                        message.error(t(_templateObject5()));
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setIsUpdating(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function onFinish() {
            return _ref.apply(this, arguments);
        };
    }();
    var supportEmailLink = /*#__PURE__*/ React.createElement("a", {
        key: "supportEmail",
        href: "mailto:".concat(SUPPORT_EMAIL),
        target: "_blank",
        rel: "noreferrer noopener"
    }, SUPPORT_EMAIL);
    return /*#__PURE__*/ React.createElement(Wrap, null, isLoading && /*#__PURE__*/ React.createElement(Loading, null), !isLoading && /*#__PURE__*/ React.createElement(Form, {
        layout: "vertical",
        requiredMark: false,
        form: form,
        initialValues: user,
        onFinish: onFinish
    }, /*#__PURE__*/ React.createElement(Field, {
        label: /*#__PURE__*/ React.createElement(Label, {
            isRequired: true
        }, t(_templateObject6())),
        name: "firstName",
        rules: [
            {
                required: true,
                message: t(_templateObject7())
            }
        ]
    }, /*#__PURE__*/ React.createElement(Input, null)), /*#__PURE__*/ React.createElement(Field, {
        label: /*#__PURE__*/ React.createElement(Label, {
            isRequired: true
        }, t(_templateObject8())),
        name: "lastName",
        rules: [
            {
                required: true,
                message: t(_templateObject9())
            }
        ]
    }, /*#__PURE__*/ React.createElement(Input, null)), /*#__PURE__*/ React.createElement(Field, {
        label: /*#__PURE__*/ React.createElement(Label, {
            isRequired: true
        }, t(_templateObject10()))
    }, /*#__PURE__*/ React.createElement(Field, {
        noStyle: true,
        name: "email",
        rules: [
            {
                type: "email",
                message: t(_templateObject11())
            }
        ]
    }, /*#__PURE__*/ React.createElement(Input, {
        disabled: true
    })), /*#__PURE__*/ React.createElement(Emphasis, null, jt(_templateObject12(), supportEmailLink))), /*#__PURE__*/ React.createElement(Field, {
        name: "language",
        label: /*#__PURE__*/ React.createElement(Label, {
            isRequired: true
        }, t(_templateObject13())),
        rules: [
            {
                required: true,
                message: t(_templateObject14())
            }
        ]
    }, /*#__PURE__*/ React.createElement(Select, {
        placeholder: t(_templateObject15()),
        "data-testid": "select-language",
        options: Object.keys(ISO_LOCALE_MAP).map(function(code) {
            return {
                value: code,
                label: LANGUAGE_BY_ISO(code)
            };
        })
    })), /*#__PURE__*/ React.createElement(StickyFooter, {
        fullWidth: true
    }, /*#__PURE__*/ React.createElement(Button, {
        type: "primary",
        htmlType: "submit",
        loading: isUpdating,
        disabled: isUpdating || isLoading
    }, isUpdating ? t(_templateObject16()) : t(_templateObject17())), /*#__PURE__*/ React.createElement(Button, {
        type: "default",
        disabled: isUpdating,
        onClick: function() {
            return history.goBack();
        }
    }, t(_templateObject18())))));
};
export default Presentation;
